import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../function/helper.js";
import Loading from "../../../modules/public/loading/loading.js";
import baseUrl from "../../../utilities/baseUrl.js";
import ExternalFactor from "./components/ExternalFactor/ExternalFactor.jsx";
import "./payResultStyle.css";

function ExternalPostFactor() {
  const params = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isFactorStatusClose, setIsFactorStatusClose] = useState(false);

  const [itemsss, setitemsss] = useState([]);

  const getFactor = async () => {
    setIsLoading(true);
    const response = await postRequestByAuth(
      `/external-post/v1/getExternalPostDetail`,
      {
        numberParcels: params.id.split(","),
      }
    );
    setIsLoading(false);

    if (response && response.status === 200) {
      if (response.data.data.length > 0) {
        setitemsss(response.data.data);

        if (
          response.data.data[0].item.factorstatus === 1 ||
          response.data.data[0].item.factorstatus === "close"
        ) {
          setIsFactorStatusClose(true);
        }

        return;
      }
    }

    Swal.fire({
      icon: "error",
      text: "در دریافت اطلاعات با خطا مواجه شدیم",
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
    });
  };

  useEffect(() => {
    getFactor();
  }, []);

  if (isLoading) return <Loading />;

  return (
    <section>
      {isFactorStatusClose === true && (
        <article
          className="position-fixed z-3 py-2 px-4 w-100 d-flex justify-content-center top-0"
          style={{ backgroundColor: "rgb(71,116,193,0.3)" }}
        >
          <Link
            className="btn btn-warning"
            to={`${baseUrl}/external-post/v1/factor?numberParcel=${itemsss.map(
              item => item.item.numberParcel
            )}`}
            target="_blank"
            rel="noreferrer"
            download={true}
          >
            پرینت فاکتور
          </Link>
        </article>
      )}

      <article className="mt-5">
        <ExternalFactor items={itemsss} />
      </article>
    </section>
  );
}

export default ExternalPostFactor;
